import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["gridSection"]

  connect() {
    this.applyKindVisibility()
  }

  kindChanged() {
    this.applyKindVisibility()
  }

  applyKindVisibility() {
    const kindSelect = this.element.querySelector("[name='stage[kind]']")
    if (!kindSelect || !this.hasGridSectionTarget) return
    this.gridSectionTarget.classList.toggle("hidden", kindSelect.value === "theatre_of_mind")
  }
}
